import adresseBo from '../Adresse'

var devisResumeBo = {
    numero: 0,
    dateCreation: '',
    adresse : Object.assign({},adresseBo)
};

export default devisResumeBo;


// WEBPACK FOOTER //
// ./src/components/data/devis/DevisResume.js